var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',[_c('a-field',{attrs:{"config":_vm.config.depositPercentage},model:{value:(_vm.depositPercentage),callback:function ($$v) {_vm.depositPercentage=$$v},expression:"depositPercentage"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }